// extracted by mini-css-extract-plugin
module.exports = {"main":"kglOO2","breadcrumb":"DowYeS","glossaryTermArticle":"XYhqcy","relatedContentsSection":"gF9OXH"};